export default {
  "chainId": "11155111",
  "genesisHash": "0x25a5cc106eea7138acab33231d7160d69cb777ee0c2c553fcddf5138993e6dd9",
  "chainInfo": {
    "id": 11155111,
    "name": "Sepolia",
    "nativeCurrency": {
      "name": "Sepolia Ether",
      "symbol": "ETH",
      "decimals": 18
    },
    "rpcUrls": {
      "default": {
        "http": [
          "https://sepolia.drpc.org"
        ]
      }
    },
    "blockExplorers": {
      "default": {
        "name": "Etherscan",
        "url": "https://sepolia.etherscan.io",
        "apiUrl": "https://api-sepolia.etherscan.io/api"
      }
    },
    "chainType": "default",
    "contracts": {
      "multicall3": {
        "address": "0xca11bde05977b3631167028862be2a173976ca11",
        "blockCreated": 751532
      },
      "ensRegistry": {
        "address": "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
      },
      "ensUniversalResolver": {
        "address": "0xc8Af999e38273D658BE1b921b88A9Ddf005769cC",
        "blockCreated": 5317080
      }
    },
    "testnet": true
  },
  "contracts": {
    "Characters": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "addr",
              "type": "address"
            }
          ],
          "name": "InvalidAddress",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "NonExistentToken",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NonceOverflow",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotAuthorized",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "provided",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "currentOwner",
              "type": "address"
            }
          ],
          "name": "NotOwner",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "TokenAlreadyExists",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "TransferRejected",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "approved",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "Approval",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "approved",
              "type": "bool"
            }
          ],
          "name": "ApprovalForAll",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "Transfer",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "approve",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }
          ],
          "name": "balanceOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "balance",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "getApproved",
          "outputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            }
          ],
          "name": "isApprovedForAll",
          "outputs": [
            {
              "internalType": "bool",
              "name": "isOperator",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint96",
              "name": "data",
              "type": "uint96"
            }
          ],
          "name": "mint",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256[]",
              "name": "tokenIDs",
              "type": "uint256[]"
            }
          ],
          "name": "ownerAndLastTransferBlockNumberList",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "lastTransferBlockNumber",
                  "type": "uint256"
                }
              ],
              "internalType": "struct IERC721WithBlocknumber.OwnerData[]",
              "name": "ownersData",
              "type": "tuple[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "ownerAndLastTransferBlockNumberOf",
          "outputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "blockNumber",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "ownerOf",
          "outputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "safeTransferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "safeTransferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "approved",
              "type": "bool"
            }
          ],
          "name": "setApprovalForAll",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes4",
              "name": "interfaceID",
              "type": "bytes4"
            }
          ],
          "name": "supportsInterface",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "transferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0x77516faf2985322dfff4db9274d9a3d053256d7d",
      "bytecode": "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",
      "argsData": "0x0000000000000000000000000256e569f883559e71febf0684d99f648fa7d00f00000000000000000000000061c461ecc993aadeb7e4b47e96d1b8cc37314b2000000000000000000000000000000000000000000000000000000000000000600000000000000000000000000000000000000000000000000000000000000000",
      "startBlock": 6177453
    },
    "Characters_Implementation": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "addr",
              "type": "address"
            }
          ],
          "name": "InvalidAddress",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "NonExistentToken",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NonceOverflow",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotAuthorized",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "provided",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "currentOwner",
              "type": "address"
            }
          ],
          "name": "NotOwner",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "TokenAlreadyExists",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "TransferRejected",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "approved",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "Approval",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "approved",
              "type": "bool"
            }
          ],
          "name": "ApprovalForAll",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "Transfer",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "approve",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }
          ],
          "name": "balanceOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "balance",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "getApproved",
          "outputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            }
          ],
          "name": "isApprovedForAll",
          "outputs": [
            {
              "internalType": "bool",
              "name": "isOperator",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint96",
              "name": "data",
              "type": "uint96"
            }
          ],
          "name": "mint",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256[]",
              "name": "tokenIDs",
              "type": "uint256[]"
            }
          ],
          "name": "ownerAndLastTransferBlockNumberList",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "owner",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "lastTransferBlockNumber",
                  "type": "uint256"
                }
              ],
              "internalType": "struct IERC721WithBlocknumber.OwnerData[]",
              "name": "ownersData",
              "type": "tuple[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "ownerAndLastTransferBlockNumberOf",
          "outputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "blockNumber",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "ownerOf",
          "outputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "safeTransferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "safeTransferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "approved",
              "type": "bool"
            }
          ],
          "name": "setApprovalForAll",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes4",
              "name": "interfaceID",
              "type": "bytes4"
            }
          ],
          "name": "supportsInterface",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            }
          ],
          "name": "transferFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0x0256e569f883559e71febf0684d99f648fa7d00f",
      "bytecode": "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",
      "argsData": "0x",
      "startBlock": 6177452
    },
    "Characters_Proxy": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "implementationAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "ownerAddress",
              "type": "address"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "stateMutability": "payable",
          "type": "constructor"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousImplementation",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            }
          ],
          "name": "ProxyImplementationUpdated",
          "type": "event"
        },
        {
          "stateMutability": "payable",
          "type": "fallback"
        },
        {
          "inputs": [],
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes4",
              "name": "id",
              "type": "bytes4"
            }
          ],
          "name": "supportsInterface",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "transferOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            }
          ],
          "name": "upgradeTo",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "upgradeToAndCall",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "stateMutability": "payable",
          "type": "receive"
        }
      ],
      "address": "0x77516faf2985322dfff4db9274d9a3d053256d7d",
      "bytecode": "0x608060405260405162000cb738038062000cb78339810160408190526200002691620001f3565b620000318262000046565b6200003d8382620000b8565b505050620002f1565b60006200006060008051602062000c978339815191525490565b90508160008051602062000c9783398151915255816001600160a01b0316816001600160a01b03167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc8054908390556040516001600160a01b0380851691908316907f5570d70a002632a7b0b3c9304cc89efb62d8da9eca0dbd7752c83b737906829690600090a381511562000195576000836001600160a01b0316836040516200013c9190620002d3565b600060405180830381855af49150503d806000811462000179576040519150601f19603f3d011682016040523d82523d6000602084013e6200017e565b606091505b505090508062000193573d806000803e806000fd5b505b505050565b80516001600160a01b0381168114620001b257600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b83811015620001ea578181015183820152602001620001d0565b50506000910152565b6000806000606084860312156200020957600080fd5b62000214846200019a565b925062000224602085016200019a565b60408501519092506001600160401b03808211156200024257600080fd5b818601915086601f8301126200025757600080fd5b8151818111156200026c576200026c620001b7565b604051601f8201601f19908116603f01168101908382118183101715620002975762000297620001b7565b81604052828152896020848701011115620002b157600080fd5b620002c4836020830160208801620001cd565b80955050505050509250925092565b60008251620002e7818460208701620001cd565b9190910192915050565b61099680620003016000396000f3fe60806040526004361061005e5760003560e01c80634f1ef286116100435780634f1ef286146101295780638da5cb5b1461013c578063f2fde38b14610176576100ca565b806301ffc9a7146100d45780633659cfe614610109576100ca565b366100ca576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600e60248201527f45544845525f52454a454354454400000000000000000000000000000000000060448201526064015b60405180910390fd5b6100d2610196565b005b3480156100e057600080fd5b506100f46100ef366004610806565b6101e1565b60405190151581526020015b60405180910390f35b34801561011557600080fd5b506100d2610124366004610871565b6103af565b6100d261013736600461088c565b610481565b34801561014857600080fd5b5061015161057c565b60405173ffffffffffffffffffffffffffffffffffffffff9091168152602001610100565b34801561018257600080fd5b506100d2610191366004610871565b6105ab565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5460003681823780813683855af491503d8082833e8280156101d7578183f35b8183fd5b50505050565b60007f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316148061027457507f7f5828d0000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b1561028157506001919050565b7fffffffff0000000000000000000000000000000000000000000000000000000080831690036102b357506000919050565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc546040517f01ffc9a70000000000000000000000000000000000000000000000000000000081527fffffffff000000000000000000000000000000000000000000000000000000008416600482015273ffffffffffffffffffffffffffffffffffffffff8216906301ffc9a790602401602060405180830381865afa92505050801561039b575060408051601f3d9081017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01682019092526103989181019061090f565b60015b6103a85750600092915050565b9392505050565b7fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035473ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610465576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600e60248201527f4e4f545f415554484f52495a454400000000000000000000000000000000000060448201526064016100c1565b61047e816040518060200160405280600081525061066a565b50565b7fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035473ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610537576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600e60248201527f4e4f545f415554484f52495a454400000000000000000000000000000000000060448201526064016100c1565b6105778383838080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525061066a92505050565b505050565b60006105a67fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035490565b905090565b7fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035473ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610661576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600e60248201527f4e4f545f415554484f52495a454400000000000000000000000000000000000060448201526064016100c1565b61047e81610759565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc80549083905560405173ffffffffffffffffffffffffffffffffffffffff80851691908316907f5570d70a002632a7b0b3c9304cc89efb62d8da9eca0dbd7752c83b737906829690600090a38151156105775760008373ffffffffffffffffffffffffffffffffffffffff16836040516107059190610931565b600060405180830381855af49150503d8060008114610740576040519150601f19603f3d011682016040523d82523d6000602084013e610745565b606091505b50509050806101db573d806000803e806000fd5b60006107837fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035490565b9050817fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d6103558173ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b60006020828403121561081857600080fd5b81357fffffffff00000000000000000000000000000000000000000000000000000000811681146103a857600080fd5b803573ffffffffffffffffffffffffffffffffffffffff8116811461086c57600080fd5b919050565b60006020828403121561088357600080fd5b6103a882610848565b6000806000604084860312156108a157600080fd5b6108aa84610848565b9250602084013567ffffffffffffffff808211156108c757600080fd5b818601915086601f8301126108db57600080fd5b8135818111156108ea57600080fd5b8760208285010111156108fc57600080fd5b6020830194508093505050509250925092565b60006020828403121561092157600080fd5b815180151581146103a857600080fd5b6000825160005b818110156109525760208186018101518583015201610938565b50600092019182525091905056fea2646970667358221220d4b8e63adccbcd059003c6af7195d51778aa436b5d3ecf7e6d5414d9adc0164d64736f6c63430008140033b53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d6103",
      "argsData": "0x0000000000000000000000000256e569f883559e71febf0684d99f648fa7d00f00000000000000000000000061c461ecc993aadeb7e4b47e96d1b8cc37314b2000000000000000000000000000000000000000000000000000000000000000600000000000000000000000000000000000000000000000000000000000000000",
      "startBlock": 6177453
    },
    "Game": {
      "abi": [
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "contract GameEnter",
                  "name": "enterRoute",
                  "type": "address"
                },
                {
                  "internalType": "contract GameLeave",
                  "name": "leaveRoute",
                  "type": "address"
                },
                {
                  "internalType": "contract GameCommit",
                  "name": "commitRoute",
                  "type": "address"
                },
                {
                  "internalType": "contract GameReveal",
                  "name": "revealRoute",
                  "type": "address"
                }
              ],
              "internalType": "struct GameRouter.Routes",
              "name": "routes",
              "type": "tuple"
            },
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "characters",
                  "type": "address"
                }
              ],
              "internalType": "struct Game.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "enum Game.Reason",
              "name": "reason",
              "type": "uint8"
            }
          ],
          "name": "InvalidMove",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyCharactersAreAccepted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "indexed": false,
              "internalType": "struct Game.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "MoveRevealed",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "bytes24",
              "name": "",
              "type": "bytes24"
            },
            {
              "internalType": "address payable",
              "name": "",
              "type": "address"
            }
          ],
          "name": "commit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "address payable",
              "name": "",
              "type": "address"
            }
          ],
          "name": "enter",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "leave",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "",
              "type": "bytes"
            }
          ],
          "name": "onERC721Received",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "internalType": "struct Game.Action[]",
              "name": "",
              "type": "tuple[]"
            },
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "name": "reveal",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0x92061c206c491e8e1d913b492835439de0491518",
      "linkedData": {
        "startTime": "0n",
        "commitPhaseDuration": "82800n",
        "revealPhaseDuration": "3600n",
        "characters": "0x77516faf2985322dfff4db9274d9a3d053256d7d"
      },
      "bytecode": "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",
      "argsData": "0x000000000000000000000000828a6ac6b4c01e87219bcb442165b429a6794d7a00000000000000000000000061c461ecc993aadeb7e4b47e96d1b8cc37314b2000000000000000000000000000000000000000000000000000000000000000600000000000000000000000000000000000000000000000000000000000000000",
      "startBlock": 6177459
    },
    "GameCommit": {
      "abi": [
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "enum Game.Reason",
              "name": "reason",
              "type": "uint8"
            }
          ],
          "name": "InvalidMove",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyCharactersAreAccepted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "indexed": false,
              "internalType": "struct Game.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "MoveRevealed",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "commit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "address",
                  "name": "controller",
                  "type": "address"
                },
                {
                  "internalType": "uint24",
                  "name": "epoch",
                  "type": "uint24"
                },
                {
                  "internalType": "bytes24",
                  "name": "commitmentHash",
                  "type": "bytes24"
                }
              ],
              "internalType": "struct GameCommit.Context",
              "name": "context",
              "type": "tuple"
            }
          ],
          "name": "computeStateChanges",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "uint24",
                  "name": "epoch",
                  "type": "uint24"
                },
                {
                  "internalType": "bytes24",
                  "name": "commitmentHash",
                  "type": "bytes24"
                }
              ],
              "internalType": "struct GameCommit.StateChanges",
              "name": "stateChanges",
              "type": "tuple"
            }
          ],
          "stateMutability": "pure",
          "type": "function"
        }
      ],
      "address": "0x0c17f61b532b4a7f42d1e82a4fd483fdfab3b29c",
      "bytecode": "0x6080806040523460155761066d908161001a8239f35b5f80fdfe60406080815260049081361015610014575f80fd5b5f3560e01c806394e434ec146101065763c77987fb14610032575f80fd5b346101025760807ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc36011261010257610069610523565b9135825260243573ffffffffffffffffffffffffffffffffffffffff8116810361010257602083015262ffffff9060443582811681036101025781840152606435927fffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000908185168503610102576100e7816060968786940152610570565b81519481518652602082015116602086015201511690820152f35b5f80fd5b5060607ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc360112610102578135916024928335907fffffffffffffffffffffffffffffffffffffffffffffffff000000000000000090818316809303610102576044359373ffffffffffffffffffffffffffffffffffffffff92838616809603610102576101926105dd565b61019a6105dd565b507ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe948536013560f01c360391868301943686116101025760806002858036038101030112610102576101eb610523565b9535865260209586810197601e8601358952605e8d830196603e810135885201358581168103610102576060830152805f52600188528c5f20335f52885260ff8d5f20541660038110156104f857156104ca57835286830197338952519451850180951161049f5780514210610477576102669051426105fd565b93801561044c5780850494600286018096116103f65762ffffff809616998a018681116104215786168281029281840414901517156103f6578c92916102ab916105fd565b5081830198895260608301998a526102c283610570565b8683820151168689830151169284519485019085821067ffffffffffffffff8311176103c657508e9f507fbd4730246898b57f6fcfe9db7a2a952d96136ed5d4808b19d6aa9ed5e762259b9a9b9c9d9e528352878301918252515f525f87528c5f2091518d1c7fffffffffff0000000000000000000000000000000000000000000000000000007affffff0000000000000000000000000000000000000000000000008454935160c01b16921617179055519551169551169551168751908152a4801515806103bd575b61039257005b5f80808093819034156103b3575b3491f1156103aa57005b513d5f823e3d90fd5b6108fc91506103a0565b5034151561038c565b90508f9250604191507f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b8d6011847f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b8e6011857f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b8c6012837f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b508a517f3a5f7b57000000000000000000000000000000000000000000000000000000008152fd5b8c6011837f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b8c517fee027da400000000000000000000000000000000000000000000000000000000815233818501528e90fd5b8e6021857f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b604051906080820182811067ffffffffffffffff82111761054357604052565b7f4e487b71000000000000000000000000000000000000000000000000000000005f52604160045260245ffd5b90604051916060830183811067ffffffffffffffff821117610543576040525f83527fffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000606060208501925f845260408601935f8552868251905262ffffff60408301511690520151169052565b6105e5610523565b905f82525f60208301525f60408301525f6060830152565b9190820391821161060a57565b7f4e487b71000000000000000000000000000000000000000000000000000000005f52601160045260245ffdfea264697066735822122063fe9b02bcfe06d69ef260afcf9f91b2aa4aa82d5daac42d2e38f69d569416a164736f6c63430008190033",
      "argsData": "0x",
      "startBlock": 6177456
    },
    "GameEnter": {
      "abi": [
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "enum Game.Reason",
              "name": "reason",
              "type": "uint8"
            }
          ],
          "name": "InvalidMove",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyCharactersAreAccepted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "indexed": false,
              "internalType": "struct Game.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "MoveRevealed",
          "type": "event"
        },
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "address",
                  "name": "sender",
                  "type": "address"
                }
              ],
              "internalType": "struct GameEnter.Context",
              "name": "context",
              "type": "tuple"
            }
          ],
          "name": "computeStateChanges",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "address",
                  "name": "controller",
                  "type": "address"
                }
              ],
              "internalType": "struct GameEnter.StateChanges",
              "name": "stateChanges",
              "type": "tuple"
            }
          ],
          "stateMutability": "pure",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "internalType": "address payable",
              "name": "payee",
              "type": "address"
            }
          ],
          "name": "enter",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenID",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "",
              "type": "bytes"
            }
          ],
          "name": "onERC721Received",
          "outputs": [
            {
              "internalType": "bytes4",
              "name": "",
              "type": "bytes4"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0xdc20d5dad8e15ec3bec3b11d87c846ea7751ddd9",
      "bytecode": "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",
      "argsData": "0x",
      "startBlock": 6177454
    },
    "GameLeave": {
      "abi": [
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "enum Game.Reason",
              "name": "reason",
              "type": "uint8"
            }
          ],
          "name": "InvalidMove",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyCharactersAreAccepted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "indexed": false,
              "internalType": "struct Game.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "MoveRevealed",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "to",
              "type": "address"
            }
          ],
          "name": "leave",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0x38fda1b0b35bb99e4ac11d8d604cd03e65feb423",
      "bytecode": "0x6080806040523460155761038f908161001a8239f35b5f80fdfe6080604081815260049081361015610015575f80fd5b5f925f3560e01c63f29953b71461002a575f80fd5b3461025a57817ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc36011261025a57823592602491823573ffffffffffffffffffffffffffffffffffffffff80821680920361025a5761008883610310565b5f83525f60606020948286820152828982015201527ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe8036013560f01c36039081019036821161025a576080600282803603810103011261025a57605e908851926100f284610310565b358352601e81013586840152603e81013589840152013590828216820361025a57606001908152865193606085019467ffffffffffffffff95818110878211176102e55789525f8152818101915f8352898201915f83528b5f52600182528a5f20335f52825260ff8b5f20541660038110156102ba571561028c573383528b81528b5f52600182528760018c5f200154168085528061025e57509087867f2bc8caf27920c0130922d6534dcaabc4ab3dc9579ce9f22ae86be323bfcbbee993519451169451168b51908152a3511695863b1561025a5760645f92838851998a9485937f42842e0e000000000000000000000000000000000000000000000000000000008552308a8601528a85015260448401525af1801561025057610215578580f35b909192938095501161022657505052005b6041907f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b84513d5f823e3d90fd5b5f80fd5b898b918d51917fe1389181000000000000000000000000000000000000000000000000000000008352820152fd5b8a517fee027da400000000000000000000000000000000000000000000000000000000815233818b01528a90fd5b8a60218b7f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b886041897f4e487b71000000000000000000000000000000000000000000000000000000005f52525ffd5b6080810190811067ffffffffffffffff82111761032c57604052565b7f4e487b71000000000000000000000000000000000000000000000000000000005f52604160045260245ffdfea2646970667358221220cd9721d98041d1a1cf703c6242251155c49de45a32447c281c411b9aebf87db464736f6c63430008190033",
      "argsData": "0x",
      "startBlock": 6177455
    },
    "GameReveal": {
      "abi": [
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "enum Game.Reason",
              "name": "reason",
              "type": "uint8"
            }
          ],
          "name": "InvalidMove",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyCharactersAreAccepted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "indexed": false,
              "internalType": "struct Game.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "MoveRevealed",
          "type": "event"
        },
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "uint64",
                  "name": "priorPosition",
                  "type": "uint64"
                },
                {
                  "internalType": "address",
                  "name": "controller",
                  "type": "address"
                },
                {
                  "internalType": "uint24",
                  "name": "epoch",
                  "type": "uint24"
                },
                {
                  "components": [
                    {
                      "internalType": "uint64",
                      "name": "position",
                      "type": "uint64"
                    },
                    {
                      "internalType": "uint192",
                      "name": "action",
                      "type": "uint192"
                    }
                  ],
                  "internalType": "struct Game.Action[]",
                  "name": "actions",
                  "type": "tuple[]"
                },
                {
                  "internalType": "bytes32",
                  "name": "secret",
                  "type": "bytes32"
                }
              ],
              "internalType": "struct GameReveal.Context",
              "name": "context",
              "type": "tuple"
            },
            {
              "internalType": "bool",
              "name": "revetOnInvalidMoves",
              "type": "bool"
            }
          ],
          "name": "computeStateChanges",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "uint64",
                  "name": "newPosition",
                  "type": "uint64"
                },
                {
                  "internalType": "uint24",
                  "name": "xp",
                  "type": "uint24"
                },
                {
                  "internalType": "uint24",
                  "name": "epoch",
                  "type": "uint24"
                },
                {
                  "internalType": "uint8",
                  "name": "hp",
                  "type": "uint8"
                },
                {
                  "components": [
                    {
                      "internalType": "int32",
                      "name": "x",
                      "type": "int32"
                    },
                    {
                      "internalType": "int32",
                      "name": "y",
                      "type": "int32"
                    },
                    {
                      "internalType": "uint8",
                      "name": "hp",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "kind",
                      "type": "uint8"
                    }
                  ],
                  "internalType": "struct GameReveal.Monster[5]",
                  "name": "monsters",
                  "type": "tuple[5]"
                },
                {
                  "components": [
                    {
                      "internalType": "uint8",
                      "name": "monsterIndexPlus1",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "cardsUsed1",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "cardsUsed2",
                      "type": "uint8"
                    }
                  ],
                  "internalType": "struct GameReveal.Battle",
                  "name": "battle",
                  "type": "tuple"
                }
              ],
              "internalType": "struct GameReveal.StateChanges",
              "name": "stateChanges",
              "type": "tuple"
            }
          ],
          "stateMutability": "pure",
          "type": "function"
        },
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "uint64",
                  "name": "priorPosition",
                  "type": "uint64"
                },
                {
                  "internalType": "address",
                  "name": "controller",
                  "type": "address"
                },
                {
                  "internalType": "uint24",
                  "name": "epoch",
                  "type": "uint24"
                },
                {
                  "components": [
                    {
                      "internalType": "uint64",
                      "name": "position",
                      "type": "uint64"
                    },
                    {
                      "internalType": "uint192",
                      "name": "action",
                      "type": "uint192"
                    }
                  ],
                  "internalType": "struct Game.Action[]",
                  "name": "actions",
                  "type": "tuple[]"
                },
                {
                  "internalType": "bytes32",
                  "name": "secret",
                  "type": "bytes32"
                }
              ],
              "internalType": "struct GameReveal.Context",
              "name": "context",
              "type": "tuple"
            }
          ],
          "name": "initialStateChanges",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "uint64",
                  "name": "newPosition",
                  "type": "uint64"
                },
                {
                  "internalType": "uint24",
                  "name": "xp",
                  "type": "uint24"
                },
                {
                  "internalType": "uint24",
                  "name": "epoch",
                  "type": "uint24"
                },
                {
                  "internalType": "uint8",
                  "name": "hp",
                  "type": "uint8"
                },
                {
                  "components": [
                    {
                      "internalType": "int32",
                      "name": "x",
                      "type": "int32"
                    },
                    {
                      "internalType": "int32",
                      "name": "y",
                      "type": "int32"
                    },
                    {
                      "internalType": "uint8",
                      "name": "hp",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "kind",
                      "type": "uint8"
                    }
                  ],
                  "internalType": "struct GameReveal.Monster[5]",
                  "name": "monsters",
                  "type": "tuple[5]"
                },
                {
                  "components": [
                    {
                      "internalType": "uint8",
                      "name": "monsterIndexPlus1",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "cardsUsed1",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "cardsUsed2",
                      "type": "uint8"
                    }
                  ],
                  "internalType": "struct GameReveal.Battle",
                  "name": "battle",
                  "type": "tuple"
                }
              ],
              "internalType": "struct GameReveal.StateChanges",
              "name": "stateChanges",
              "type": "tuple"
            }
          ],
          "stateMutability": "pure",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "internalType": "struct Game.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "internalType": "bytes32",
              "name": "secret",
              "type": "bytes32"
            }
          ],
          "name": "reveal",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "uint64",
                  "name": "newPosition",
                  "type": "uint64"
                },
                {
                  "internalType": "uint24",
                  "name": "xp",
                  "type": "uint24"
                },
                {
                  "internalType": "uint24",
                  "name": "epoch",
                  "type": "uint24"
                },
                {
                  "internalType": "uint8",
                  "name": "hp",
                  "type": "uint8"
                },
                {
                  "components": [
                    {
                      "internalType": "int32",
                      "name": "x",
                      "type": "int32"
                    },
                    {
                      "internalType": "int32",
                      "name": "y",
                      "type": "int32"
                    },
                    {
                      "internalType": "uint8",
                      "name": "hp",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "kind",
                      "type": "uint8"
                    }
                  ],
                  "internalType": "struct GameReveal.Monster[5]",
                  "name": "monsters",
                  "type": "tuple[5]"
                },
                {
                  "components": [
                    {
                      "internalType": "uint8",
                      "name": "monsterIndexPlus1",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "cardsUsed1",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "cardsUsed2",
                      "type": "uint8"
                    }
                  ],
                  "internalType": "struct GameReveal.Battle",
                  "name": "battle",
                  "type": "tuple"
                }
              ],
              "internalType": "struct GameReveal.StateChanges",
              "name": "stateChanges",
              "type": "tuple"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "internalType": "struct Game.Action",
              "name": "action",
              "type": "tuple"
            },
            {
              "internalType": "bool",
              "name": "revetOnInvalidMoves",
              "type": "bool"
            }
          ],
          "name": "stepChanges",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "characterID",
                  "type": "uint256"
                },
                {
                  "internalType": "uint64",
                  "name": "newPosition",
                  "type": "uint64"
                },
                {
                  "internalType": "uint24",
                  "name": "xp",
                  "type": "uint24"
                },
                {
                  "internalType": "uint24",
                  "name": "epoch",
                  "type": "uint24"
                },
                {
                  "internalType": "uint8",
                  "name": "hp",
                  "type": "uint8"
                },
                {
                  "components": [
                    {
                      "internalType": "int32",
                      "name": "x",
                      "type": "int32"
                    },
                    {
                      "internalType": "int32",
                      "name": "y",
                      "type": "int32"
                    },
                    {
                      "internalType": "uint8",
                      "name": "hp",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "kind",
                      "type": "uint8"
                    }
                  ],
                  "internalType": "struct GameReveal.Monster[5]",
                  "name": "monsters",
                  "type": "tuple[5]"
                },
                {
                  "components": [
                    {
                      "internalType": "uint8",
                      "name": "monsterIndexPlus1",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "cardsUsed1",
                      "type": "uint8"
                    },
                    {
                      "internalType": "uint8",
                      "name": "cardsUsed2",
                      "type": "uint8"
                    }
                  ],
                  "internalType": "struct GameReveal.Battle",
                  "name": "battle",
                  "type": "tuple"
                }
              ],
              "internalType": "struct GameReveal.StateChanges",
              "name": "",
              "type": "tuple"
            }
          ],
          "stateMutability": "pure",
          "type": "function"
        }
      ],
      "address": "0x4d1431aa2a3eb08c0784b8bf167043bd7e290593",
      "bytecode": "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",
      "argsData": "0x",
      "startBlock": 6177457
    },
    "Game_Implementation": {
      "abi": [
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "contract GameEnter",
                  "name": "enterRoute",
                  "type": "address"
                },
                {
                  "internalType": "contract GameLeave",
                  "name": "leaveRoute",
                  "type": "address"
                },
                {
                  "internalType": "contract GameCommit",
                  "name": "commitRoute",
                  "type": "address"
                },
                {
                  "internalType": "contract GameReveal",
                  "name": "revealRoute",
                  "type": "address"
                }
              ],
              "internalType": "struct GameRouter.Routes",
              "name": "routes",
              "type": "tuple"
            },
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "startTime",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "commitPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "revealPhaseDuration",
                  "type": "uint256"
                },
                {
                  "internalType": "contract IERC721",
                  "name": "characters",
                  "type": "address"
                }
              ],
              "internalType": "struct Game.Config",
              "name": "config",
              "type": "tuple"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [],
          "name": "GameNotStarted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "enum Game.Reason",
              "name": "reason",
              "type": "uint8"
            }
          ],
          "name": "InvalidMove",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            }
          ],
          "name": "NotAuthorizedController",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyCharactersAreAccepted",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint64",
              "name": "position",
              "type": "uint64"
            }
          ],
          "name": "UnableToExitFromThisPosition",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "indexed": false,
              "internalType": "bytes24",
              "name": "commitmentHash",
              "type": "bytes24"
            }
          ],
          "name": "CommitmentMade",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "EnteredTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "positionWhenLeaving",
              "type": "uint64"
            }
          ],
          "name": "LeftTheGame",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "characterID",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "controller",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint24",
              "name": "epoch",
              "type": "uint24"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "indexed": false,
              "internalType": "struct Game.Action[]",
              "name": "actions",
              "type": "tuple[]"
            },
            {
              "indexed": false,
              "internalType": "uint64",
              "name": "newPosition",
              "type": "uint64"
            }
          ],
          "name": "MoveRevealed",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "bytes24",
              "name": "",
              "type": "bytes24"
            },
            {
              "internalType": "address payable",
              "name": "",
              "type": "address"
            }
          ],
          "name": "commit",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "address payable",
              "name": "",
              "type": "address"
            }
          ],
          "name": "enter",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "leave",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "",
              "type": "bytes"
            }
          ],
          "name": "onERC721Received",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "components": [
                {
                  "internalType": "uint64",
                  "name": "position",
                  "type": "uint64"
                },
                {
                  "internalType": "uint192",
                  "name": "action",
                  "type": "uint192"
                }
              ],
              "internalType": "struct Game.Action[]",
              "name": "",
              "type": "tuple[]"
            },
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "name": "reveal",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "address": "0x828a6ac6b4c01e87219bcb442165b429a6794d7a",
      "bytecode": "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",
      "argsData": "0x000000000000000000000000dc20d5dad8e15ec3bec3b11d87c846ea7751ddd900000000000000000000000038fda1b0b35bb99e4ac11d8d604cd03e65feb4230000000000000000000000000c17f61b532b4a7f42d1e82a4fd483fdfab3b29c0000000000000000000000004d1431aa2a3eb08c0784b8bf167043bd7e290593000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000143700000000000000000000000000000000000000000000000000000000000000e1000000000000000000000000077516faf2985322dfff4db9274d9a3d053256d7d",
      "startBlock": 6177458
    },
    "Game_Proxy": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "implementationAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "ownerAddress",
              "type": "address"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "stateMutability": "payable",
          "type": "constructor"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousImplementation",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            }
          ],
          "name": "ProxyImplementationUpdated",
          "type": "event"
        },
        {
          "stateMutability": "payable",
          "type": "fallback"
        },
        {
          "inputs": [],
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes4",
              "name": "id",
              "type": "bytes4"
            }
          ],
          "name": "supportsInterface",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "transferOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            }
          ],
          "name": "upgradeTo",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newImplementation",
              "type": "address"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "name": "upgradeToAndCall",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
        {
          "stateMutability": "payable",
          "type": "receive"
        }
      ],
      "address": "0x92061c206c491e8e1d913b492835439de0491518",
      "bytecode": "0x608060405260405162000cb738038062000cb78339810160408190526200002691620001f3565b620000318262000046565b6200003d8382620000b8565b505050620002f1565b60006200006060008051602062000c978339815191525490565b90508160008051602062000c9783398151915255816001600160a01b0316816001600160a01b03167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc8054908390556040516001600160a01b0380851691908316907f5570d70a002632a7b0b3c9304cc89efb62d8da9eca0dbd7752c83b737906829690600090a381511562000195576000836001600160a01b0316836040516200013c9190620002d3565b600060405180830381855af49150503d806000811462000179576040519150601f19603f3d011682016040523d82523d6000602084013e6200017e565b606091505b505090508062000193573d806000803e806000fd5b505b505050565b80516001600160a01b0381168114620001b257600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b83811015620001ea578181015183820152602001620001d0565b50506000910152565b6000806000606084860312156200020957600080fd5b62000214846200019a565b925062000224602085016200019a565b60408501519092506001600160401b03808211156200024257600080fd5b818601915086601f8301126200025757600080fd5b8151818111156200026c576200026c620001b7565b604051601f8201601f19908116603f01168101908382118183101715620002975762000297620001b7565b81604052828152896020848701011115620002b157600080fd5b620002c4836020830160208801620001cd565b80955050505050509250925092565b60008251620002e7818460208701620001cd565b9190910192915050565b61099680620003016000396000f3fe60806040526004361061005e5760003560e01c80634f1ef286116100435780634f1ef286146101295780638da5cb5b1461013c578063f2fde38b14610176576100ca565b806301ffc9a7146100d45780633659cfe614610109576100ca565b366100ca576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600e60248201527f45544845525f52454a454354454400000000000000000000000000000000000060448201526064015b60405180910390fd5b6100d2610196565b005b3480156100e057600080fd5b506100f46100ef366004610806565b6101e1565b60405190151581526020015b60405180910390f35b34801561011557600080fd5b506100d2610124366004610871565b6103af565b6100d261013736600461088c565b610481565b34801561014857600080fd5b5061015161057c565b60405173ffffffffffffffffffffffffffffffffffffffff9091168152602001610100565b34801561018257600080fd5b506100d2610191366004610871565b6105ab565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5460003681823780813683855af491503d8082833e8280156101d7578183f35b8183fd5b50505050565b60007f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316148061027457507f7f5828d0000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b1561028157506001919050565b7fffffffff0000000000000000000000000000000000000000000000000000000080831690036102b357506000919050565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc546040517f01ffc9a70000000000000000000000000000000000000000000000000000000081527fffffffff000000000000000000000000000000000000000000000000000000008416600482015273ffffffffffffffffffffffffffffffffffffffff8216906301ffc9a790602401602060405180830381865afa92505050801561039b575060408051601f3d9081017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01682019092526103989181019061090f565b60015b6103a85750600092915050565b9392505050565b7fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035473ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610465576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600e60248201527f4e4f545f415554484f52495a454400000000000000000000000000000000000060448201526064016100c1565b61047e816040518060200160405280600081525061066a565b50565b7fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035473ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610537576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600e60248201527f4e4f545f415554484f52495a454400000000000000000000000000000000000060448201526064016100c1565b6105778383838080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525061066a92505050565b505050565b60006105a67fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035490565b905090565b7fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035473ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610661576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600e60248201527f4e4f545f415554484f52495a454400000000000000000000000000000000000060448201526064016100c1565b61047e81610759565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc80549083905560405173ffffffffffffffffffffffffffffffffffffffff80851691908316907f5570d70a002632a7b0b3c9304cc89efb62d8da9eca0dbd7752c83b737906829690600090a38151156105775760008373ffffffffffffffffffffffffffffffffffffffff16836040516107059190610931565b600060405180830381855af49150503d8060008114610740576040519150601f19603f3d011682016040523d82523d6000602084013e610745565b606091505b50509050806101db573d806000803e806000fd5b60006107837fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035490565b9050817fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d6103558173ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b60006020828403121561081857600080fd5b81357fffffffff00000000000000000000000000000000000000000000000000000000811681146103a857600080fd5b803573ffffffffffffffffffffffffffffffffffffffff8116811461086c57600080fd5b919050565b60006020828403121561088357600080fd5b6103a882610848565b6000806000604084860312156108a157600080fd5b6108aa84610848565b9250602084013567ffffffffffffffff808211156108c757600080fd5b818601915086601f8301126108db57600080fd5b8135818111156108ea57600080fd5b8760208285010111156108fc57600080fd5b6020830194508093505050509250925092565b60006020828403121561092157600080fd5b815180151581146103a857600080fd5b6000825160005b818110156109525760208186018101518583015201610938565b50600092019182525091905056fea2646970667358221220d4b8e63adccbcd059003c6af7195d51778aa436b5d3ecf7e6d5414d9adc0164d64736f6c63430008140033b53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d6103",
      "argsData": "0x000000000000000000000000828a6ac6b4c01e87219bcb442165b429a6794d7a00000000000000000000000061c461ecc993aadeb7e4b47e96d1b8cc37314b2000000000000000000000000000000000000000000000000000000000000000600000000000000000000000000000000000000000000000000000000000000000",
      "startBlock": 6177459
    }
  },
  "name": "sepolia"
} as const;